 import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getBookings = async () => {
  const response = await axios.get(`${base_url}booking/`,config);
  return response.data;
};

const deleteBooking = async (id) => {
  const response = await axios.delete(`${base_url}booking/${id}`, config);
  return response.data;
};

const getBooking = async (id) => {
  const response = await axios.get(`${base_url}booking/${id}`,config);
  return response.data;
};

const updateBooking = async (data) => {
  const response = await axios.put(
    `${base_url}booking/${data.id}`,
    { status: data.bookingData },
    config
  );

  return response.data;
};

const getUnreadBookings = async () => {
  const response = await axios.get(`${base_url}booking/unread-bookings`, config);
  return response.data;
};

const markBookingAsRead = async (data) => {
  const response = await axios.put(
    `${base_url}booking/${data.id}/mark-as-read`,
    {},
    config
  );
  return response.data;
};

const submitFeedback = async ({ id, email, originalComment, userName, feedback, staffMember }) => {
  const response = await axios.post(
    `${base_url}booking/feedback`,
    { id, userName, originalComment, email, feedback, staffMember },
    config
  );
  return response.data;
};

const bookingService = {
  getBookings,
  deleteBooking,
  getBooking,
  updateBooking,
  submitFeedback,
  getUnreadBookings,
  markBookingAsRead,
};

export default bookingService;
